import { FaPhoneAlt, FaMapMarkerAlt, FaFacebookF, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import { IoLogoInstagram, IoLogoYoutube } from 'react-icons/io';
import Link from 'next/link';

export default function Footer({ websiteData }) {
  const { website, menus } = websiteData || {};

  const footerMenuItems = menus?.FOOTER_MENU?.items?.[0]?.subItems || [];

  return (
    <>

      <footer className="bg-[#334821] text-white">
        {/* {JSON.stringify(websiteData)} */}
        <div className="container mx-auto px-4 pt-12 pb-2">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

            <div className="flex flex-col">
              <div className="mb-4">
                {website?.logo ? (
                  <img
                    src={website.logo}
                    alt="Website Logo"
                    width={250}
                    height={64}
                    className="h-14 w-auto max-h-[250px] max-w-[250px] md:h-16"
                    loading="lazy"
                    decoding="async"
                  />
                ) : (
                  <h2 className="text-2xl font-bold text-[#f1bb62]">{website?.title}</h2>
                )}
              </div>
              <p className="text-sm leading-relaxed opacity-80">
                {website?.description}
              </p>
            </div>

            <div className="flex flex-col md:ml-20">
              <h3 className="text-xl font-semibold mb-6 text-[#f1bb62]">Contact Us</h3>

              <div className="flex items-start mb-4">
                <div className="mr-3 mt-1 text-[#f1bb62]">
                  <FaPhoneAlt size={16} />
                </div>
                <div>
                  <h4 className="font-semibold">Call</h4>
                  {/* Phone Number Link */}
                  <Link
                    href={`tel:${website?.contactNumber?.[0]}`}
                    className="text-sm text-white hover:text-white hover:underline"
                  >
                    {website?.contactNumber?.[0]}
                  </Link>
                  <span className='text-white'> ,</span>
                  {website?.contactNumber?.[1] && <Link
                    href={`tel:${website?.contactNumber?.[1]}`}
                    className="text-sm mx-1 text-white hover:text-white hover:underline"
                  >
                    {website?.contactNumber?.[1]}
                  </Link>}
                </div>
              </div>





              <div className="flex items-start">
                <div className="mr-3 mt-1 text-[#f1bb62]">
                  <FaMapMarkerAlt size={16} />
                </div>
                <div>
                  <h4 className="font-semibold">Address</h4>
                  <p className="text-sm opacity-80">{website?.address}</p>
                </div>
              </div>

              <div className="flex flex-col items-start mt-2 pl-8">
                <h4 className="font-semibold">Social Links</h4>
                <div className='flex gap-2 mt-2'>
                  {websiteData?.website?.socialLinks?.facebook && (
                    <a
                      href={websiteData?.website?.socialLinks?.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity"
                      aria-label="Facebook"
                    >
                      <FaFacebookF size={16} />
                    </a>
                  )}
                  {websiteData?.website?.socialLinks?.linkedIn && (
                    <a
                      href={websiteData?.website?.socialLinks?.linkedIn}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity"
                      aria-label="LinkedIn"
                    >
                      <FaLinkedinIn size={16} />
                    </a>
                  )}
                  {websiteData?.website?.socialLinks?.instagram && (
                    <a
                      href={websiteData?.website?.socialLinks?.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 w-8 h-8 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity"
                      aria-label="Instagram"
                    >
                      <IoLogoInstagram size={16} />
                    </a>
                  )}
                  {websiteData?.website?.socialLinks?.twitter && (
                    <a
                      href={websiteData?.website?.socialLinks?.twitter}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity"
                      aria-label="Twitter"
                    >
                      <FaTwitter size={16} />
                    </a>
                  )}
                  {websiteData?.website?.socialLinks?.youtube && (
                    <a
                      href={websiteData?.website?.socialLinks?.youtube}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-[white] text-[#334821] w-8 h-8 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity"
                      aria-label="YouTube"
                    >
                      <IoLogoYoutube size={16} />
                    </a>
                  )}

                </div>
              </div>
            </div>

            <div className="flex flex-col">
              <h3 className="text-xl font-semibold mb-6 text-[#f1bb62]">Quick Links</h3>
              <ul className="space-y-2">
                {footerMenuItems.map((item, index) => (
                  <li key={index} className="hover:text-[#f1bb62] transition-colors">
                    <Link href={item.url || "#"} className="text-sm">
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* <div className="border-t border-[#f1bb62]/30 my-2"></div> */}


        </div>
      </footer>


      <section className='bg-[#f1bc62]'>
        <div className='container mx-auto'>
          <div className="flex flex-col md:flex-row justify-between items-center py-1">
            <p className="text-sm opacity-80">
              © Copyrights {new Date().getFullYear()} {website?.title} All rights reserved
            </p>

            <p className="group text-sm">
              <Link
                href="https://edukitapp.com/"
                target="_blank"
                rel="noopener noreferrer"

              >
                Design &amp; Developed By{" "}
                <span className="group-hover:text-blue-700 group-hover:underline">
                  Edukit
                </span>
              </Link>
            </p>




          </div>

        </div>

      </section>

    </>
  );
}

